import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const EMPTY = { name:'', phone:'', vehicle_type:'bike', license_plate:'', store_id:'' };

export default function Drivers() {
  const [drivers, setDrivers] = useState([]);
  const [stores, setStores]   = useState([]);
  const [search, setSearch]   = useState('');
  const [modal, setModal]     = useState(false);
  const [form, setForm]       = useState(EMPTY);
  const [editing, setEditing] = useState(null);
  const [saving, setSaving]   = useState(false);

  const load = useCallback(() => {
    const params = search ? { search } : {};
    axios.get('/api/drivers', { params }).then(r => setDrivers(r.data.drivers || r.data));
  }, [search]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => { axios.get('/api/stores').then(r => setStores(r.data.stores || r.data)); }, []);

  const openNew  = () => { setForm(EMPTY); setEditing(null); setModal(true); };
  const openEdit = d => { setForm({ name:d.name, phone:d.phone, vehicle_type:d.vehicle_type, license_plate:d.license_plate||'', store_id:d.store_id||'' }); setEditing(d.id); setModal(true); };
  const closeModal = () => setModal(false);

  const save = async e => {
    e.preventDefault(); setSaving(true);
    try {
      if (editing) { await axios.put(`/api/drivers/${editing}`, form); toast.success('Driver updated'); }
      else         { await axios.post('/api/drivers', form); toast.success('Driver created'); }
      closeModal(); load();
    } catch (err) { toast.error(err.response?.data?.error || 'Save failed'); }
    finally { setSaving(false); }
  };

  const toggleActive = async d => {
    try {
      await axios.put(`/api/drivers/${d.id}`, { ...d, is_active: d.is_active ? 0 : 1 });
      toast.success('Updated'); load();
    } catch { toast.error('Failed'); }
  };

  return (
    <div>
      <div className="page-header">
        <div><h1>Drivers</h1><p>Manage your delivery fleet</p></div>
        <button className="btn btn--primary" onClick={openNew}>+ Add Driver</button>
      </div>

      <div className="card">
        <div className="toolbar">
          <input className="form-control" placeholder="Search drivers…" value={search}
            onChange={e => setSearch(e.target.value)} style={{ maxWidth: 260 }} />
        </div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Name</th><th>Phone</th><th>Vehicle</th><th>Plate</th><th>Store</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>
              {drivers.map(d => (
                <tr key={d.id}>
                  <td><strong>{d.name}</strong></td>
                  <td>{d.phone}</td>
                  <td style={{ textTransform:'capitalize' }}>{d.vehicle_type}</td>
                  <td>{d.license_plate || '—'}</td>
                  <td>{d.store_name || '—'}</td>
                  <td>
                    <span className={`badge badge--${d.is_active ? 'active' : 'inactive'}`}>
                      {d.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td style={{ display:'flex', gap:8 }}>
                    <button className="btn btn--ghost btn--sm" onClick={() => openEdit(d)}>Edit</button>
                    <button className="btn btn--ghost btn--sm" onClick={() => toggleActive(d)}>
                      {d.is_active ? 'Deactivate' : 'Activate'}
                    </button>
                  </td>
                </tr>
              ))}
              {drivers.length === 0 && <tr><td colSpan={7}><div className="empty-state"><div className="icon">🏍️</div>No drivers found</div></td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      {modal && (
        <div className="modal-backdrop" onClick={e => e.target === e.currentTarget && closeModal()}>
          <div className="modal">
            <h2>{editing ? 'Edit Driver' : 'Add Driver'}</h2>
            <form onSubmit={save}>
              {[['name','Name','text',true],['phone','Phone','tel',true],['license_plate','License Plate','text',false]].map(([f,l,t,r]) => (
                <div className="form-field" key={f}>
                  <label>{l}{r && ' *'}</label>
                  <input className="form-control" type={t} required={r} value={form[f]}
                    onChange={e => setForm({ ...form, [f]: e.target.value })} />
                </div>
              ))}
              <div className="form-field">
                <label>Vehicle Type *</label>
                <select className="form-control" value={form.vehicle_type} onChange={e => setForm({ ...form, vehicle_type: e.target.value })}>
                  {['bike','motorcycle','car','van','truck'].map(v => <option key={v} value={v}>{v}</option>)}
                </select>
              </div>
              <div className="form-field">
                <label>Assigned Store</label>
                <select className="form-control" value={form.store_id} onChange={e => setForm({ ...form, store_id: e.target.value })}>
                  <option value="">— None —</option>
                  {stores.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                </select>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn--ghost" onClick={closeModal}>Cancel</button>
                <button type="submit" className="btn btn--primary" disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
